import { render } from "./TagLevel.vue?vue&type=template&id=53052984&scoped=true"
import script from "./TagLevel.vue?vue&type=script&lang=js"
export * from "./TagLevel.vue?vue&type=script&lang=js"

import "./TagLevel.vue?vue&type=style&index=0&id=53052984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53052984"]])

export default __exports__